import { stitch } from 'keo';

import { logout } from 'utils/jwt';

const componentDidMount = () => {
    logout();
};

const render = () => null;

export default stitch({ componentDidMount, render });



// WEBPACK FOOTER //
// ./src/components/public/Logout/index.js